/** A placeholder function that does nothing. */
export const noOp = (): void => {};

/** Utility function to scroll the specified id into view using vanillaJS. */
export const scrollIntoView = (id: string): void =>
  document
    .getElementById(id)
    ?.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
